import { render, staticRenderFns } from "./Chairs.vue?vue&type=template&id=50101195&scoped=true"
import script from "./Chairs.vue?vue&type=script&lang=js"
export * from "./Chairs.vue?vue&type=script&lang=js"
import style0 from "./Chairs.vue?vue&type=style&index=0&id=50101195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50101195",
  null
  
)

export default component.exports